import { render } from "./ResultatsRelocalisation.vue?vue&type=template&id=390c3922&scoped=true"
import script from "./ResultatsRelocalisation.vue?vue&type=script&lang=js"
export * from "./ResultatsRelocalisation.vue?vue&type=script&lang=js"

import "./ResultatsRelocalisation.vue?vue&type=style&index=0&id=390c3922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390c3922"]])

export default __exports__